import SortAlt from "@icons/sort-alt.svg?react";
import { t } from "@lingui/core/macro";
import { useSearchParams } from "react-router-dom";

import { MergeSearchParamsLink } from "@/common/components/search-params-link/search-params-link";
import { GetReportsSortOrder } from "@/generated/api/news";

const params = {
  sortOrder: "sort-order",
} as const;

const SortOrder = () => {
  const [searchParams] = useSearchParams();
  const sortOrder = searchParams.get(params.sortOrder);
  const nextSortOrder = sortOrder === "ASC" ? "DESC" : "ASC";

  return (
    <MergeSearchParamsLink
      className="flex items-center gap-2 self-center font-can-inter"
      to={`?${params.sortOrder}=${nextSortOrder}`}
    >
      {sortOrder === "DESC" ? t`Nejnovější` : t`Nejstarší`} <SortAlt />
    </MergeSearchParamsLink>
  );
};

const initialSortOrder = {
  [params.sortOrder]: GetReportsSortOrder.DESC,
};

export { initialSortOrder, SortOrder };
